export default __webpack_public_path__ + "assets/audios/708e537415d8b1dbb98a93ff075d2b9d.mp3";